<app-card class="page-container">
  <app-card-header>
    <app-card-title class="flex gap-md flex-column">
      @if (!loading() && form()) {
        <div class="view-header flex gap-md flex-wrap flex-align-center flex-justify-end">
          <app-checkpoint-form-header
            class="mr-auto"
            [checkpointName]="checkPoint()?.name ?? ''"
            [formName]="form()!.name"
            [serialNumber]="$safeNavigationMigration(instance()?.serial_number)"
            data-testid="checkpoint-info"
          />
          <app-button
            type="button"
            variant="outlined"
            (click)="goBack()"
            data-testid="back-to-history-button"
          >
            <app-icon name="arrow-left" />
            {{ 'submission.view.backToHistory' | translate }}
          </app-button>
        </div>
        <div class="submission-metadata" data-testid="submission-metadata">
          @if (submittedAt) {
            <span class="metadata-item">
              <app-icon name="clock" [size]="14" />
              {{ 'submission.view.submittedAt' | translate }}: {{ submittedAt | date: 'medium' }}
            </span>
          }
          @if (recordedBy) {
            <span class="metadata-item">
              <app-icon name="user" [size]="14" />
              {{ 'submission.view.recordedBy' | translate }}: {{ recordedBy }}
            </span>
          }
        </div>
      }
      @if (loading()) {
        <span>{{ 'submission.view.loading' | translate }}</span>
      }
    </app-card-title>
  </app-card-header>

  <app-card-content>
    @if (loading()) {
      <div class="center-content">
        <app-spinner />
      </div>
    }

    @if (error() && !loading()) {
      <div class="error-message" data-testid="error-message">
        <app-icon name="alert-circle" />
        {{ error() }}
      </div>
    }

    @if (!loading() && !error()) {
      <div class="form-container">
        @if (fields.length === 0) {
          <div class="no-form-message">
            <p>{{ 'submission.form.noCustomFields' | translate }}</p>
          </div>
        } @else {
          <formly-form
            [attr.data-columns]="formColumns()"
            [form]="formlyGroup"
            [fields]="fields"
            [model]="model"
            [options]="formlyOptions"
          ></formly-form>
        }
      </div>
    }
  </app-card-content>
</app-card>
